import { render, staticRenderFns } from "./CalendarFilter.vue?vue&type=template&id=0638b454&scoped=true"
import script from "./CalendarFilter.js?vue&type=script&lang=js&external"
export * from "./CalendarFilter.js?vue&type=script&lang=js&external"
import style0 from "./CalendarFilter.vue?vue&type=style&index=0&id=0638b454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0638b454",
  null
  
)

export default component.exports